import React, { useState } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Button, Container, IconButton, InputAdornment, Paper, TextField, Typography, Alert, } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import logo from '../../assests/logo.png';
import ellipse1 from '../../assests/Ellipse 1.png';
import ellipse2 from '../../assests/Ellipse 2.png';

const ResetPassword = () => {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const { userId, token } = useParams();
  const navigate = useNavigate();

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleClickShowConfirmPassword = () => setShowConfirmPassword((show) => !show);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      setError("Passwords don't match");
      setMessage('');
      return;
    }

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/auth/reset-password/${userId}/${token}`, {
        newPassword,
      });
      setMessage(response.data.message);
      setError('');
      setTimeout(() => navigate('/'), 3000);
    } catch (err) {
      setError(err.response?.data?.msg || 'Something went wrong');
      setMessage('');
    }
  };

  return (
    <Box
      sx={{ height: '100vh', width: '100%', position: 'relative', bgcolor: '#010B2A', overflow: 'auto', }}>
      <Box sx={{ position: 'relative', height: '100%', width: '100%', overflow: 'hidden' }}>
        <Box component="img" src={ellipse1} alt="Background circle"
          sx={{ position: 'absolute', width: { xs: '100%', md: '840px' }, height: 'auto', top: 0, right: 0, zIndex: 0, }} />
        <Box component="img" src={ellipse2} alt="Background circle"
          sx={{ position: 'absolute', width: { xs: '100%', md: '810px' }, height: 'auto', bottom: 0, left: 0, zIndex: 0, }} />
      </Box>
      <Box component="img" src={logo} alt="Logo"
        sx={{
          position: 'absolute', width: { xs: '150px', sm: '180px', md: '225px' }, height: 'auto',
          top: { xs: '20px', sm: '30px', md: '49px' }, left: { xs: '20px', sm: '50px', md: '102px' },
        }} />
      <Container maxWidth={false} disableGutters
        sx={{
          position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
          display: 'flex', alignItems: 'center', justifyContent: 'center', padding: { xs: 2, sm: 3, md: 4 },
        }}>
        <Paper
          elevation={0}
          sx={{
            width: { xs: '100%', sm: '80%', md: '570px' }, padding: { xs: 3, sm: 4, md: 5 }, display: 'flex',
            flexDirection: 'column', alignItems: 'center', gap: { xs: 2, sm: 3, md: 4 }, backgroundColor: 'rgba(202, 202, 202, 0.23)',
            backdropFilter: 'blur(2px)', borderRadius: '12px', border: '2px solid white',
          }} >
          <Typography variant="h4" component="h1"
            sx={{ fontWeight: 600, color: 'white', textAlign: 'center', fontFamily: "'Inter', Helvetica", }} >
            Reset Password
          </Typography>

          {message && (
            <Alert severity="success" sx={{ width: '100%', mb: 2 }}>
              {message}
            </Alert>
          )}
          {error && (
            <Alert severity="error" sx={{ width: '100%', mb: 2 }}>
              {error}
            </Alert>
          )}

          <Box component="form" onSubmit={handleSubmit} sx={{ width: '100%', maxWidth: { xs: '100%', sm: '400px', md: '453px' } }} >
            <Box sx={{ mb: { xs: 2, sm: 2.5 } }}>
              <Typography sx={{ color: '#DBD6D6', mb: 0.5, fontFamily: "'Inter', Helvetica", fontSize: { xs: '14px', sm: '16px' }, }} >
                Password
              </Typography>
              <TextField fullWidth required name="newPassword" label="" type={showPassword ? 'text' : 'password'}
                variant="outlined" value={newPassword} onChange={(e) => setNewPassword(e.target.value)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton aria-label="toggle password visibility" onClick={handleClickShowPassword} edge="end" >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                  sx: { height: { xs: '40px', sm: '45px', md: '50px' }, backgroundColor: 'rgba(255, 255, 255, 0.27)', borderRadius: '8px', color: 'white', },
                }}
                inputProps={{
                  style: { color: 'white' },
                }} />
            </Box>
            <Box sx={{ mb: { xs: 2, sm: 2.5, md: 3 } }}>
              <Typography sx={{ color: '#DBD6D6', mb: 0.5, fontFamily: "'Inter', Helvetica", fontSize: { xs: '14px', sm: '16px' }, }} >
                Confirm Password
              </Typography>
              <TextField fullWidth required name="confirmPassword" label=""
                type={showConfirmPassword ? 'text' : 'password'} variant="outlined" value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton aria-label="toggle password visibility" onClick={handleClickShowConfirmPassword} edge="end" >
                        {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                  sx: {
                    height: { xs: '40px', sm: '45px', md: '50px' },
                    backgroundColor: 'rgba(255, 255, 255, 0.27)', borderRadius: '8px', color: 'white',
                  },
                }}
                inputProps={{ style: { color: 'white' }, }} />
            </Box>
            <Button type="submit" fullWidth variant="contained"
              sx={{
                height: { xs: '40px', sm: '45px', md: '50px' }, borderRadius: '8px', textTransform: 'none',
                fontSize: { xs: '14px', sm: '16px' }, backgroundColor: '#3366FF', '&:hover': { backgroundColor: '#2952CC', },
              }} >
              Set Password
            </Button>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default ResetPassword;